import { render, staticRenderFns } from "./isMyDataPrivateCard.vue?vue&type=template&id=8bcff86e&scoped=true"
import script from "./isMyDataPrivateCard.vue?vue&type=script&lang=js"
export * from "./isMyDataPrivateCard.vue?vue&type=script&lang=js"
import style0 from "./isMyDataPrivateCard.vue?vue&type=style&index=0&id=8bcff86e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcff86e",
  null
  
)

export default component.exports